import { render, staticRenderFns } from "./like-btn.vue?vue&type=template&id=52a743be&"
import script from "./like-btn.vue?vue&type=script&lang=js&"
export * from "./like-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports